import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import { api } from '../../utils';

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [newProjectName, setNewProjectName] = useState('');
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const response = await api.get('link-building/projects/');
      setProjects(response.data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setNewProjectName('');
  };

  const handleCreateProject = async () => {
    if (!newProjectName.trim()) return;
    setCreating(true);
    try {
      await api.post('link-building/projects/', { name: newProjectName });
      toggleModal();
      fetchProjects();
    } catch (error) {
      console.error("Error creating project:", error);
      alert(error.response?.data?.error || "Error creating project.");
    } finally {
      setCreating(false);
    }
  };

  const nameFormatter = (cell, row) => {
    return <Link to={`/link-building/projects/${row.id}`}>{cell}</Link>;
  };

  const columns = [
    { dataField: 'id', text: 'ID', sort: true, hidden: true },
    { dataField: 'name', text: 'Project Name', sort: true, formatter: nameFormatter },
    { dataField: 'created_at', text: 'Created At', sort: true },
  ];

  return (
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="container-fluid">
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Link Building Projects</h3>
                <Button color="success" size="sm" onClick={toggleModal}>
                  <i className="fas fa-plus mr-2" /> Create Project
                </Button>
              </CardHeader>
              <CardBody>
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <BootstrapTable
                    bootstrap4
                    keyField="id"
                    data={projects}
                    columns={columns}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={modalOpen} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Create New Link Building Project</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="projectName">Project Name</Label>
              <Input 
                type="text" 
                id="projectName" 
                placeholder="Enter project name..." 
                value={newProjectName}
                onChange={(e) => setNewProjectName(e.target.value)}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleCreateProject} disabled={creating || !newProjectName.trim()}>
              {creating ? 'Creating...' : 'Create'}
            </Button>{' '}
            <Button color="secondary" onClick={toggleModal} disabled={creating}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default ProjectList;
